<template>
  <div class="couponForm">
    <el-dialog
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :visible.sync="isShow"
      top="10vh"
      width="900px"
      title="优惠券"
    >
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="`未使用(${dataNum.use_state_no})`" name="0" />
        <el-tab-pane :label="`已使用(${dataNum.use_state_yes})`" name="1" />
        <el-tab-pane :label="`已过期(${dataNum.use_state_overdue})`" name="2" />
      </el-tabs>
      <div class="couPonListBox">
        <div v-if="activeName == 0" class="weishiyzj">现金券
          <span style="color: #FF0B0B;">{{Numberofdiscounts.moneyCont}}</span> 张可用，总价值
          <span style="color: #FF0B0B;">{{Numberofdiscounts.amount}}</span> 元；折扣券
          <span style="color: #FF0B0B;">{{Numberofdiscounts.discountCont}}</span> 张可用，最高
          <span style="color: #FF0B0B;">{{Numberofdiscounts.minDiscount}}</span> 折
        </div>
        <el-row v-if="dataList && dataList.length" class="couponList">
          <el-col
            :span="10"
            :offset="1"
            class="couponLi"
            :style="{ height: item.isUp ? '150px' : '136px' }"
            v-for="item in dataList"
            :key="item.id"
          >
            <div class="top">
              <!-- :class="item.description? 'top' : 'topbor'" -->
              <div class="top-left" :class="{ couponLiDue: activeName == 2 }">
                <span>{{ formatNumber(item.face_value, item.type) }}</span>
                <span v-if="item.type == 1" class="money">元</span>
                <span v-if="item.type == 2" class="money">折</span>
              </div>
              <div class="top-right">
                <div class="titleBox">
                  <p class="title">{{ item.name }}</p>
                  <template>
                    <p
                      v-if="activeName == 0"
                      class="btn"
                      @click="gotoUse(item)"
                    >
                      去使用
                    </p>
                    <p v-else-if="activeName == 1" class="btn touse">已使用</p>
                    <p v-else class="btn claimed">已过期</p>
                  </template>
                </div>
                <div class="time">
                  {{ formatNumberyi(item.start_time) || "----" }} -
                  {{ formatNumberyi(item.end_time) || "----" }}
                </div>
                <div class="checkCode">
                  <p>
                    核销码：<span>{{
                      item.isCode ? item.verification_code : "**********"
                    }}</span>
                  </p>
                  <div class="operation">
                    <img
                      :src="
                        item.isCode
                          ? require('@/assets/imgs/viewOpen.png')
                          : require('@/assets/imgs/viewClose.png')
                      "
                      @click="isShowHide(item, 'isCode')"
                      alt=""
                    />
                    <img
                      src="@/assets/imgs/copy.png"
                      @click="copyTextTap(item.verification_code)"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom">
              <span
                :class="[
                  item.description && item.description.length > 18 && !item.isUp
                    ? 'whiteSpace'
                    : '',
                ]"
              >
                使用规则：{{ item.description || "------" }}
              </span>
              <img
                v-if="item.description && item.description.length > 18"
                :src="
                  !item.isUp
                    ? require('@/assets/imgs/select_up.png')
                    : require('@/assets/imgs/select_down.png')
                "
                alt=""
                @click="isShowHide(item, 'isUp')"
              />
            </div>
          </el-col>
        </el-row>
        <div v-else class="empty-data">
          <img src="@/assets/imgs/kong.png" />
          <span class="empty-text">暂无数据</span>
        </div>
      </div>
    </el-dialog>
    <couponsProductDialog
      ref="couponsProductDialog"
      :dialogVisible="isCouponProductDialog"
      :goodsList="goodsList"
      :fans_id="fans_id"
      :channel_id="channel_id"
      @showGoodsQrCode="showGoodsQrCode"
      @close="proDuctClose"
    />
  </div>
</template>

<script>
import tool from '@/kits/Tools.js'
import qs from 'qs'
import couponsProductDialog from './couponsProductDialog'
import { formatNumber } from '@/utils'

export default {
  name: 'CouponForm',
  components: { couponsProductDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    fans_id: {
      type: String | Number,
      default: ''
    },
    channel_id: {
      type: String | Number,
      default: ''
    }
  },
  data () {
    return {
      activeName: '0',
      dataList: [],
      dataNum: {
        use_state_no: 0,
        use_state_yes: 0,
        use_state_overdue: 0
      },
      isCouponProductDialog: false,
      goodsList: [],
      Numberofdiscounts: {}
    }
  },
  computed: {
    isShow: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.close()
      }
    }
  },
  methods: {
    getUnusedMyFansCoupon () {
      // 学员优惠券
      const data = {} // 'https://prehy_online.shkt.online'
      this.axios.post(tool.getTestSchoolApi() + '/fansCoupon/getUnusedMyFansCoupon', qs.stringify(data))
        .then(res => {
          // eslint-disable-next-line eqeqeq
          if (res.data.code == 200) {
            this.Numberofdiscounts = res.data.data
          }
        })
    },
    formatNumberyi (item) {
      return item.substring(0, 10)
    },
    formatNumber,
    handleClick (tab) {
      this.initData(tab.name)
    },
    initData (name) {
      this.dataList = []
      this.getCouponCount()
      this.getCouponList(name)
      this.getUnusedMyFansCoupon()
    },
    getCouponList (state) {
      var data = {
        use_state: state
      }
      this.axios
        .post(
          tool.getTestSchoolApi() + '/fansCoupon/getMyFansCouponList',
          qs.stringify(data)
        )
        .then((res) => {
          if (res.data.code === 200) {
            this.dataList = res.data.data
          } else {
            this.dataList = []
            this.$message.error(res.data.message)
          }
        })
    },
    getCouponCount () {
      this.axios
        .post(tool.getTestSchoolApi() + '/fansCoupon/getMyFansCouponCount')
        .then((res) => {
          if (res.data.code === 200) {
            this.dataNum = res.data.data
          } else {
            this.dataNum = {
              use_state_no: 0,
              use_state_yes: 0,
              use_state_overdue: 0
            }
          }
        })
    },
    gotoUse (row) {
      if (row.goods_list && row.goods_list.length > 0) {
        this.isCouponProductDialog = true
        this.goodsList = row.goods_list
      } else {
        this.$message.error('请联系老师进行使用')
      }
    },
    isShowHide (item, code) {
      this.$set(item, code, item[code])
      item[code] = !item[code]
    },
    copyTextTap (text) {
      // 复制过滤
      // eslint-disable-next-line no-useless-escape
      let reg = /\<a(.*?)\>(\S*)\<\/a>/
      let resultArr = text.match(reg)
      if (resultArr && resultArr[2]) {
        text = resultArr[2]
      }

      var oInput = document.createElement('input') // 创建一个隐藏input（重要！）
      oInput.value = text // 赋值
      document.body.appendChild(oInput)
      oInput.select() // 选择对象
      document.execCommand('Copy') // 执行浏览器复制命令
      oInput.style.display = 'none'
      document.body.removeChild(oInput)
      this.$message.success('复制成功')
    },
    proDuctClose () {
      this.isCouponProductDialog = false
    },
    showGoodsQrCode (id) {
      this.$emit('showGoodsQrCode', id)
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.weishiyzj {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #666666;
  margin-bottom: 16px;
}
.couPonListBox {
  height: 420px;
  padding-bottom: 10px;
}
.couponList {
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  width: 100%;
  max-height: 420px;
  justify-content: start;
  overflow-y: auto;
}
.couponLi {
  width: calc(50% - 24px);
  height: 136px;
  margin-bottom: 12px;
  font-size: 12px;
  padding: 10px 10px 12px;
  background: #ffffff;
  border: 1px solid #e5e8ec;
  border-radius: 10px;
}
.couponLiyi {
  height: 97px;
}
.couponLi:nth-child(odd) {
  margin-left: 0;
}
.couponLi .top {
  display: flex;
  border-bottom: 1px dashed #e2e2e2;
  padding-bottom: 10px;
}
.couponLi .topbor {
  border-bottom: none;
}
.top .top-left {
  width: 80px;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  font-weight: 600;
  -webkit-background-clip: text;
  background-clip: text;
  color: #ff6827;
}
.top .couponLiDue {
  color: #999999;
  background: none;
}
.top .top-left .money {
  font-size: 14px;
  height: 28px;
  line-height: 36px;
}
.top .top-right {
  flex: 1;
  margin-left: 10px;
}
.top-right .titleBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.titleBox .title {
  font-size: 14px;
  color: #202020;
  font-weight: bold;
  width: 74%;
  line-height: 20px;
  word-break: break-all;
  word-wrap: break-word;
  text-align: justify;
}
.titleBox .btn {
  width: 64px;
  height: 26px;
  line-height: 26px;
  color: #fff;
  font-size: 12px;
  border-radius: 12px;
  text-align: center;
  cursor: pointer;
  background: linear-gradient(293deg, #fc692f 0%, #fcaf40 100%);
  position: absolute;
  margin-left: 228px;
  margin-top: 50px;
}
.titleBox .touse {
  border: 1px solid #ffa410;
  color: #ffffff;
  cursor: initial;
  opacity: 0.6;
  background: #ff953b;
}
.titleBox .claimed {
  cursor: initial;
  background: #cccccc;
  color: #ffffff;
}
.top-right .time {
  margin-top: 10px;
  color: #999;
  text-align: left;
  font-size: 14px;
}
.top-right .checkCode {
  margin-top: 10px;
  display: flex;
}
.top-right .checkCode p {
  display: flex;
  align-items: center;
  color: #666;
  font-size: 14px;
}
.top-right .checkCode .operation {
  margin-left: 10px;
  width: 42px;
  display: flex;
  justify-content: space-between;
}
.top-right .checkCode .operation img {
  width: 16px;
}
.bottom {
  margin-top: 10px;
  color: #999;
  display: flex;
  position: relative;
}
.bottom span {
  flex: 1;
  margin-right: 5px;
  padding-right: 5px;
  line-height: 16px;
  word-break: break-all;
  word-wrap: break-word;
  text-align: justify;
}
.bottom .whiteSpace {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.bottom img {
  width: 10px;
  height: 10px;
}
img {
  cursor: pointer;
}

.empty-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 420px;
}
.empty-data img {
  width: 160px;
  height: 160px;
}
.empty-data .empty-text {
  font-size: 14px;
  color: #979ca3;
  margin-top: 10px;
}
.couponForm /deep/ .el-dialog__body {
  padding-top: 0;
}
.couponForm /deep/ .el-tabs__item.is-active {
  color: #ff6827;
}
.couponForm /deep/ .el-tabs__active-bar {
  background: linear-gradient(272deg, #fc692f 0%, #fcaf40 100%);
}
/* 修改滚动条的样式 */
/* 滚动条整体样式 */
::-webkit-scrollbar {
  width: 4px; /* 滚动条宽度 */
  height: 58px;
  padding-left: 10px;
}

/* 滚动条轨道样式 */
::-webkit-scrollbar-track {
  background: #f8f7f7; /* 滚动条轨道背景色 */
}

/* 滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.18); /* 滚动条滑块颜色 */
  border-radius: 6px; /* 滑块圆角 */
}

/* 鼠标悬停在滑块上的样式 */
::-webkit-scrollbar-thumb:hover {
  background: #727171; /* 悬停时的颜色 */
}
</style>



// WEBPACK FOOTER //
// src/components/couponsComponents/couponForm.vue